import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/toPromise';
import { CustomHttp, ApiConstants } from '../../shared';
import {CatalogService} from '../../catalogue/catalog-api/catalog.service';

@Injectable()
export class VideoManageService {

    constructor(private router: Router,
        private apiConstants: ApiConstants,
        private http: CustomHttp,
        private catalogService: CatalogService) {
    }

    isClaimed(selectedShow) {
        const parrotId = selectedShow.parrot_id;
        let index;
        const contentType = selectedShow.content_type;
        if (contentType === 'tv' || contentType === 'show') {
            index = 'series_metadata';
        }else if (contentType === 'talent') {
            index = 'talent_metadata';
        }else if (contentType === 'movie') {
            index = 'movie_metadata';
        }else {
            index = 'series_metadata';
        }
        return new Promise((resolve, reject) => {
            this.catalogService.callEsProxyForParrotIdsUsingIndex([parrotId], ['internal_data.claimed_by'], index)
                .then((res) => {
                    if (res.hits.hits && res.hits.hits[0]['_source']['internal_data'] &&
                        res.hits.hits[0]['_source']['internal_data']['claimed_by']) {
                        resolve(res.hits.hits[0]['_source']['internal_data']['claimed_by']);
                    } else {
                        resolve(false);
                    }
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    setClaimed(parrotId, user, contentType) {
        return new Promise((resolve, reject) => {
            this.catalogService.updateGenome([parrotId], ['claimed_by'], [user], contentType)
                .then((res) => {
                    resolve(true);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    getHarvestedQARequest(parrotId: string) {
        const uri = this.apiConstants.ENDPOINT_HARVESTED_QA + '?parrot_id=' + parrotId;

        return this.http.get(uri);
    }

    createHarvestedQARequest(parrotId: string, requestUser: string) {
        const uri = this.apiConstants.ENDPOINT_HARVESTED_QA;
        const payload = {
            parrot_id: parrotId,
            request_user: requestUser
        };

        return this.http.post(uri, payload);
    }

    updateHarvestedQARequest(id: number, completedByUser: string, state: 'APPROVED' | 'REJECTED', contentType) {
        const uri = this.apiConstants.ENDPOINT_HARVESTED_QA +
            `/update?id=${id}&completed_by_user=${completedByUser}&state=${state}&content_type=${contentType}`;

        return this.http.post(uri, {});
    }
}



// WEBPACK FOOTER //
// ./src/app/youtube-video/video-manage/video-manage.service.ts